<template>
  <Session>
    <slot />
  </Session>
</template>
